import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import { useLocation, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcInspection } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";

const ShowWebinarChats = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const username = queryParams.get("username");

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      `/webinar/view-webinar-chats-by-id/${id}?username=${username}`
    )
      .then((res) => {
        if (res.status === 201) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting employee feedback!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  function makeLinksClickable(text) {
    if (!text || typeof text !== "string") return text;

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const formattedText = text?.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
    return formattedText;
  }

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcInspection className="fs-2 me-1" />
                  Webinar Chat
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Webinar Chat</h2>
            </div>

            <div className="card-body">
              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Webinar Name:</label>
                <div className="w-100 col">
                  {data?.[0]?.webinar?.webinarName || "N/A"}
                </div>
                <label className="w-25 form-label col-3">User Name:</label>
                <div className="w-100 col">{data?.[0]?.userName || "N/A"}</div>
              </div>
              {data &&
                data
                  .filter((message) => message?.userQuestion?.trim())
                  .map((message, index) => (
                    <div key={index} className="chat-item mb-3">
                      <div className="row align-items-end">
                        <div className="col col-lg-12">
                          <div
                            className={`chat-bubble ${
                              message.from === "admin"
                                ? "bg-secondary-lt"
                                : "chat-bubble-me"
                            }`}
                          >
                            <div className="chat-bubble-title">
                              <div className="row">
                                <div className="col col-12 chat-bubble-author">
                                  {message?.userQuestion?.toUpperCase()}
                                </div>
                                <div className="col-auto clo-12 chat-bubble-date">
                                  {makeLinksClickable(message?.gptAnswer)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
            </div>
            <div className="card-footer">
              <div className="text-end">
                <SimpleButton buttonText="CANCEL" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ShowWebinarChats;
